import { RouteDefinition } from "@solidjs/router";

import { DbsPositions } from "../components/platform-admin/DbsPositions.jsx";
import { UserRoleType } from "../schema/graphql.js";
import { RouteGuard } from "./RouteGuard.jsx";

export const platformAdminRoutes: RouteDefinition[] = [
  {
    path: "/platform-admin",
    children: [
      {
        path: "/dbs-positions",
        component: () => (
          <RouteGuard rolesAllowed={[UserRoleType.Admin]}>
            <DbsPositions />
          </RouteGuard>
        ),
      },
    ],
  },
];
